<div class="d-lg-flex justify-content-between">
  <div>
    <div class="mb-3">
      <span class="text-bold me-2" [translate]="'receipt.pickup'"></span>

      <i class="icon-pencil pointer text-blue-2 me-2 lh-1"
         *ngIf="showDeliveryEdit"
         (click)="onDeliveryEdit.emit()"></i>

      <ui-order-line-status-badge
        *ngIf="deliveryOrder.state === ORDER_LINE_STATES.EDITED"
        [status]="deliveryOrder.state"
      ></ui-order-line-status-badge>
    </div>

    <table class="font-md">
      <tr class="mb-1 mb-sm-max-2">
        <td class="text-muted pe-3">
          <span [translate]="'receipt.pickupTime'"></span>
        </td>
        <td>
          <span class="first-letter-capitalize d-inline-block">
            {{deliveryOrder.deliveryDate | i18nDate : 'dddd D MMM'}}
          </span>

          {{deliveryOrder.deliveryTime}}
        </td>
      </tr>

      <tr>
        <td class="text-muted pe-3">
          <span [translate]="'receipt.bakery'"></span>:
        </td>
        <td>
          {{order.bakery.name}}
        </td>
      </tr>

      <tr>
        <td class="text-muted pe-3">
          <span [translate]="'receipt.pickupPoint'"></span>
        </td>
        <td>
          {{deliveryOrder.outlet.name}}
        </td>
      </tr>

      <tr>
        <td class="text-muted pe-3">
          <span [translate]="'receipt.pickupPointAddress'"></span>
        </td>
        <td>
          {{deliveryOrder.outlet.address}},
          {{deliveryOrder.outlet.postNumber}}&nbsp;
          {{deliveryOrder.outlet.cityName}}&nbsp;
        </td>
      </tr>
    </table>

  </div>

  <div class="mt-md-max-3">
    <ng-content></ng-content>
  </div>
</div>

